export const ONEID_CLIENT_ID = 'monitoring_agro_uz';
export const ONEID_SCOPE = 'eMtV44Hr385WZ5RxgFNqnfAc';
export const ONEID_URL = 'https://sso.egov.uz/sso/oauth/Authorization.do';
export const redirect_uri = 'https://monitoring.agro.uz/login';

export const URL = `${ONEID_URL}?response_type=one_code&client_id=${ONEID_CLIENT_ID}&redirect_uri=${redirect_uri}&scope=${ONEID_SCOPE}&state=testState`;
